import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import PolicyModal from '../components/PolicyModal';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '', phone: '', password: '', first_name: '', last_name: '',
    gender: 'male', date_of_birth: '', marital_status: 'never_married', referral_code: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [showPolicy, setShowPolicy] = useState(null); // 'privacy' | 'terms' | null
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) return;
    setError('');
    setLoading(true);
    try {
      await register(formData);
      navigate('/verify-otp');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      {showPolicy && <PolicyModal type={showPolicy} onClose={() => setShowPolicy(null)} />}
      <div className="auth-topbar">
        <Link to="/about" className="auth-topbar-link">About Us</Link>
      </div>
      <div className="auth-left">
        <div className="auth-brand">
          <img src="/logo.png" alt="Manthrakodi Matrimony" className="auth-brand-logo" />
        </div>
        <div className="auth-tagline">
          <h2>Begin your journey to a happy marriage</h2>
          <ul>
            <li>✓ Free registration</li>
            <li>✓ Thousands of verified profiles</li>
            <li>✓ Advanced matchmaking</li>
          </ul>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
          <h2>Create Account</h2>
          <p className="auth-subtitle">Register for free and find your match</p>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input name="first_name" placeholder="First name" onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input name="last_name" placeholder="Last name" onChange={handleChange} />
              </div>
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input name="email" type="email" placeholder="Enter your email" onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input name="phone" type="tel" placeholder="Enter your phone" onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input name="password" type="password" placeholder="Create a password" onChange={handleChange} required />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Gender</label>
                <select name="gender" onChange={handleChange} required>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label>Date of Birth</label>
                <input name="date_of_birth" type="date" onChange={handleChange} required />
              </div>
            </div>
            <div className="form-group">
              <label>Marital Status</label>
              <select name="marital_status" onChange={handleChange} required>
                <option value="never_married">Never Married</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
                <option value="separated">Separated</option>
              </select>
            </div>

            <div className="form-group">
              <label>Referral Code (optional)</label>
              <input name="referral_code" placeholder="Enter referral code" onChange={handleChange} />
            </div>

            <div className="terms-checkbox">
              <label>
                <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} />
                <span>
                  I agree to the{' '}
                  <button type="button" className="terms-link" onClick={() => setShowPolicy('terms')}>Terms and Conditions</button>
                  {' '}and{' '}
                  <button type="button" className="terms-link" onClick={() => setShowPolicy('privacy')}>Privacy Policy</button>
                </span>
              </label>
            </div>

            {error && <p className="error-msg">{error}</p>}
            <button type="submit" className="btn-primary" disabled={loading || !agreed}>
              {loading ? 'Creating Account...' : 'Register Free'}
            </button>
          </form>

          <p className="auth-switch">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
